<template>
  <div class="customize_container">
    <div class="customize_title">
      <!-- <div class="step">Step 2</div> -->
      <div class="step_title">選擇你想要的金牌樣式</div>
    </div>
    <div class="center">
      <div class="customize_step2">
        <div class="description">
          <div
            v-for="(style, index) in displayStyleChoice"
            :key="index"
            @click="
              updateStyleChoise(
                style.name,
                style.accessory[0],
                index,
                style.code
              )
            "
            class="item buttonitem"
          >
            {{ style.name }}
          </div>
        </div>
      </div>
      <div class="pic_changed">
        <img v-bind:src="displayImg" alt="" />
      </div>
    </div>
    <StepPreNext
      @preClick="$router.push({ name: 'customize_step1' })"
      @nextClick="$router.push({ name: 'customize_step3' })"
    ></StepPreNext>
  </div>
</template>

<script>
import StepPreNext from "@/components/StepPreNext.vue";
import { updateEngravingContent } from "@/utils/engravingContentHelper.js";
export default {
  name: "customizeStep2",
  components: {
    StepPreNext,
  },
  data() {
    return {
      displayStyleChoice: "",
      currentStyle: "",
      displayImg: "",
    };
  },
  created() {
    let shape = this.$store.getters.currentCustom.shape;
    this.displayStyleChoice =
      this.$store.getters.customizeMetalDataByShape(shape);
    this.currentStyle = this.$store.getters.currentCustom.style;
    let componentCode = this.$store.getters.getComponentCode;
    this.displayImg = require(`@/images/metal_${componentCode.toLowerCase()}@2x.png`);
  },
  mounted() {
    let allItem = document.querySelectorAll(".buttonitem");
    this.displayStyleChoice.forEach((item, index) => {
      if (item.name == this.currentStyle) {
        allItem[index].classList.add("active");
      }
    });
  },
  methods: {
    updateStyleChoise(styleName, styleDefaultAccessory, index, code) {
      const currentType =
        this.$store.getters.currentCustom.engraving_content.type;
      const currentContent =
        this.$store.getters.currentCustom.engraving_content.content;

      this.$store.dispatch("updateCostom", {
        key: "style",
        content: styleName,
      });
      this.$store.dispatch("updateCostom", {
        key: "accessory",
        content: styleDefaultAccessory,
      });
      updateEngravingContent(this.$store, code, currentType, currentContent);

      this.activeItemStyle(index);
      this.changeComponents(code);
    },
    activeItemStyle(index) {
      let allItem = document.querySelectorAll(".buttonitem");
      allItem.forEach((item) => {
        item.classList.remove("active");
      });
      allItem[index].classList.add("active");
    },
    changeComponents(code) {
      (this.displayImg = require(`@/images/metal_${code.toLowerCase()}@2x.png`)),
        this.$store.dispatch("updateComponentCode", code);
    },
  },
};
</script>

<style scoped lang="scss">
.customize_container {
  position: relative;
  margin-top: 30px;
  margin-bottom: 60px;
  ::v-deep .step-pre-next {
    @include table {
      top: 360px;
    }
  }
}
.customize_title {
  color: $primaryDeepColor;
  font-size: 24px;
  font-family: "NotoSerifTC-Bold";
}
.center {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 30px 120px;
  z-index: 99;
  position: relative;
  @media all and (min-width: 1440px) {
    margin: 30px 8.3%;
  }
  @include table {
    grid-template-columns: 1fr;
    z-index: 1;
  }
  @include betweenPhoneTable {
    margin: 30px 0px;
  }
}
.customize_step2 {
  align-self: center;
  @include table {
    order: 2;
  }
}
.description {
  display: grid;
  grid-template-columns: repeat(2, 240px);
  grid-gap: 10px;
  justify-content: center;
  color: $primaryLightColor;
  font-size: 24px;
  @include betweenDesktopTablePro {
    grid-template-columns: repeat(1, 210px);
  }

  @media screen and (max-width: 950px) and (min-width: 768px) {
    grid-template-columns: repeat(1, 150px);
    font-size: 17px;
  }
  .item {
    padding: 10px 5px;
    border: 1px $primaryLightColor solid;
    cursor: pointer;
    &:hover {
      background-color: $primaryLightColor;
      color: $secondaryColor3;
    }
    @include betweenTableTablePro {
      padding: 10px 0;
    }
  }
  .active {
    background-color: $primaryLightColor;
    color: $secondaryColor3;
  }
}
.pic_changed {
  width: 500px;
  margin-bottom: 30px;
  padding: 0 10px;
  img {
    width: 500px;
    height: 400px;
    object-fit: contain;
  }
  @include betweenTableTablePro {
    width: 400px;
    img {
      width: 400px;
      height: 320px;
      object-fit: contain;
    }
  }
  @include table {
    order: 1;
    width: 350px;
    justify-self: center;
    margin-bottom: 115px;
    padding: 0px;
    img {
      width: 350px;
      height: 280px;
      object-fit: contain;
    }
  }
  @include phone {
    width: 320px;
    margin-bottom: 150px;
    img {
      width: 320px;
      height: 256px;
      object-fit: contain;
    }
  }
}
</style>
